import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { maxBy } from 'lodash'

import Void from '../../../components/tabs/OrderDetailsModal/Void'

import { requestRefund } from '../../../actions/refund'

import { makeGetTabOrder } from '../../../selectors/order'
import { makeGetDisplaySuiteByOrder } from '../../../selectors/suites'

import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'

const mapStateToProps = (state, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const getTabOrder = makeGetTabOrder()
  const getDisplaySuite = makeGetDisplaySuiteByOrder()
  const suiteInformation = getDisplaySuite(state, orderId)
  const tabOrder = getTabOrder(state, orderId)
  const order = TabOrderDetailsViewModel(tabOrder)
  const remoteOrderTotal = maxBy([order.orderTotalFromOrder, order.remoteOrderTotal], 'updatedAt') || {}

  const userNotes = order?.userNotes ?? ''
  const customerId = order?.customerId ?? ''
  const revenueCenterId = order?.revenueCenterUuid ?? ''
  const isOrderLatestFromServer = tabOrder?.latestFromServer ?? false

  return {
    ...order,
    customerId,
    isOrderLatestFromServer,
    remoteOrderTotal,
    revenueCenterId,
    suiteInformation,
    userNotes,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const replace = ownProps?.history?.replace ?? function(){}

  return {
    onClose: () => replace('/tabs'),
    onRequestVoid: ({ orderId, itemIndexes, lineItemIds, itemIds, reason, isComp }) => {
      dispatch(requestRefund({ orderId, itemIndexes, itemIds, lineItemIds, reason, isComp }))
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Void))
